import { Skeleton } from '@ds';
import { useGetUserProfilesImage } from 'src/shared/queries/useGetUserProfilesImage';
import { useGetUser } from 'src/shared/queries/useGetUser';
import ProfileInitials from '../ProfileInitials/ProfileInitials';
import styles from './ProfileImage.module.scss';

const SkeletonDefaultSize = 32;

const ProfileImage = (props: { size?: number }) => {
  const { size } = props;
  const { data: userInfo } = useGetUser();
  const { data: profileImage, isFetching } = useGetUserProfilesImage(userInfo?.userId);

  if (isFetching) {
    return <Skeleton width={`${size || SkeletonDefaultSize}px`} height={`${size || SkeletonDefaultSize}px`} />;
  }

  if (!profileImage || profileImage.includes('assets/Avatar_Temp.png')) {
    return <ProfileInitials firstName={userInfo?.firstName} lastName={userInfo?.lastName} />;
  }

  const sizeStyle = size ? { width: `${size}px`, height: `${size}px` } : {};

  return (
    <div
      className={styles['profile-image-avatar']}
      style={{ ...sizeStyle, backgroundImage: `url(${profileImage})` }}
    ></div>
  );
};

export default ProfileImage;
